import React, { memo } from 'react'

type IntroType = {
  title: string
  lead: string
  caption?: string
}

export const Intro: React.FC<IntroType> = memo(({ title, lead, caption }) => {
  return (
    <section
      className="px-6 lg:h-[278px] h-[224px] flex flex-col justify-center bg-intro-pattern-pc bg-cover bg-no-repeat bg-center"
      style={{
        background: "center / cover no-repeat url('/images/img_intro.webp')"
      }}
    >
      <div className="max-w-[1200px] mx-auto w-full">
        <h1
          className="text-lg sm:text-4xl font-bold"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {lead && lead.trim().length > 0 && (
          <p
            className="lg:text-xl lg:mt-5 text-sm mt-3"
            dangerouslySetInnerHTML={{ __html: lead }}
          />
        )}
        {caption && caption.trim().length > 0 && (
          <p
            className="text-[10px] md:text-[12px] lg:mt-5 mt-3"
            dangerouslySetInnerHTML={{ __html: caption }}
          />
        )}
      </div>
    </section>
  )
})

Intro.displayName = 'Intro'
